import { render, staticRenderFns } from "./licitacaoItem.vue?vue&type=template&id=b851a626&scoped=true"
import script from "./licitacaoItem.ts?vue&type=script&lang=ts&external"
export * from "./licitacaoItem.ts?vue&type=script&lang=ts&external"
import style0 from "./licitacaoItem.vue?vue&type=style&index=0&id=b851a626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b851a626",
  null
  
)

export default component.exports